// extracted by mini-css-extract-plugin
export default {"result":"TestResult_result__jA4wo","result__title":"TestResult_result__title__BQTIT","result__data":"TestResult_result__data__j5tg+"};